import { Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Modal from "../../components/Modal";
import TextFields from "../../components/TextField";
import ClearIcon from "@mui/icons-material/Clear";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import { Pagination } from "../../components/pagination/Pagination";
import useDocumentProfile from "./Hooks/useDocumentProfile";

const DocumentProfile = () => {
  const { data, methods } = useDocumentProfile();
  const {
    openModal,
    controller,
    documentList,
    totalCount,
    formData,
    personalDoc,
  } = data;
  const {
    handleChange,
    handleOpenModal,
    handleCloseModal,
    AddDocument,
    handleRemoveFile,
    handleFileChange,
    updateDocument,
    updateDelete,
    handlePagination
  } = methods;
  return (
    <div>
      <div className=" my-4">
        <Button
          onClick={() => handleOpenModal("add")}
          className="dropDownButtons11 ms-4"
        >
          <AddIcon /> Add New
        </Button>
      </div>

    <div className="pt-3 px-4">
  <h3>Documents</h3>
  <hr />

  {documentList?.map((item, index) => (
    <div key={item._id} className="row mb-4">
<div className="d-flex align-items-center justify-content-between">

      <div className="mt-4">
        <p>
          <span className="fw-bold">Document :</span>
          <span className="text-muted ms-2">{item?.name || "--"}</span>
        </p>
      </div>

      <div className="mt-4">
        <div>
        <IconButton  onClick={() => handleOpenModal('edit', item)}><BorderColorIcon color="primary"/></IconButton>
        <IconButton onClick={()=>updateDelete(item._id)}><DeleteIcon color="error"/></IconButton>
        </div>
      </div>
</div>



<div className="col-lg-12 mt-4">
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "14px",
      paddingTop: "10px"
    }}
  >
    {item.documents?.map((cur, fileIndex) => {
      const filetype = cur.split(".").pop().toLowerCase();
      const fileUrl = `${personalDoc}${cur}`;

      // Common container style
      const boxStyle = {
        width: "90px",
        height: "90px",
        border: "1px solid #e3e3e3",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        cursor: "pointer",
        background: "#fafafa"
      };

      // IMAGE
      if (["jpg", "jpeg", "png"].includes(filetype)) {
        return (
          <div key={fileIndex} style={boxStyle}>
            <img
              src={fileUrl}
              alt="doc"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onClick={() => window.open(fileUrl)}
            />
          </div>
        );
      }

      // VIDEO
    //   if (["mp4", "wmv", "mov"].includes(filetype)) {
    //     return (
    //       <div key={fileIndex} style={boxStyle}>
    //         <video
    //           src={fileUrl}
    //           controls
    //           style={{ width: "100%", height: "100%", objectFit: "cover" }}
    //           onClick={() => window.open(fileUrl)}
    //         />
    //       </div>
    //     );
    //   }

      // OTHER FILES (PDF, DOC, TXT etc.)
      return (
        <div key={fileIndex} style={boxStyle}>
          <i
            className="fa-sharp fa-regular fa-file"
            style={{ fontSize: "48px", color: "red" }}
            onClick={() => window.open(fileUrl)}
          ></i>
        </div>
      );
    })}
  </div>
</div>
<hr className="mt-4" />

    </div>
  ))}


 {documentList.length === 0 && (
  <div style={{ textAlign: "center", padding: "20px", color: "#888" }}>
    <h5>No documents found</h5>
  </div>
)}

                  <Pagination
                    count={totalCount}
                    controller={controller}
                    setController={handlePagination}
                  />
</div>


      <Modal
        size="md"
        show={openModal.addDocument || openModal.editDocument}
        onHide={handleCloseModal}
        headerContent={
          <h5>{openModal.editDocument ? "Edit Document" : "Add Document"}</h5>
        }
        bodyContent={
          <div className="">
            <div className="row">
              <div className="pt-2">
                <TextFields
                  Lable="Name"
                  Name="name"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChange}
                  Value={formData.name}
                  Require={true}
                  width={100}
                />
              </div>

              <div>
                <div className="col-lg-12">
                  <label htmlFor="docUpload">
                    <input
                      id="docUpload"
                      type="file"
                      accept=".jpg,.jpeg,.png,.pdf"
                      multiple
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                    <h6
                      className="navi_clr pointer mt-3"
                      style={{ color: "#297eb3" }}
                    >
                      +Attach a file
                    </h6>
                  </label>
                </div>

                <div className="col-lg-12 Ticket_Attachment">
                  <div className="row">
                    {formData.documents?.map((file, fileIndex) => {
                      const ext = file.split(".").pop().toLowerCase();
                      const url = `${personalDoc}${file}`;

                      // Image
                      if (["jpg", "jpeg", "png", "gif"].includes(ext)) {
                        return (
                          <div
                            key={fileIndex}
                            className="col-4 mb-3 position-relative"
                          >
                            <img
                              src={url}
                              className="pointer"
                              alt="doc"
                              onClick={() => window.open(url)}
                            />
                            <span onClick={() => handleRemoveFile(fileIndex)}>
                              X
                            </span>
                          </div>
                        );
                      }

                      // Video
                      if (["mp4", "wmv", "mov"].includes(ext)) {
                        return (
                          <div
                            key={fileIndex}
                            className="col-4 mb-3 position-relative"
                          >
                            <video src={url} controls />
                            <span onClick={() => handleRemoveFile(fileIndex)}>
                              X
                            </span>
                          </div>
                        );
                      }

                      // Other File Types
                      return (
                        <div
                          key={fileIndex}
                          className="col-4 mb-3 position-relative"
                          style={{ width: "65px" }}
                        >
                          <i
                            className="fa-sharp fa-regular fa-file pointer"
                            onClick={() => window.open(url)}
                            style={{ fontSize: "48px", color: "red" }}
                          ></i>
                          <span onClick={() => handleRemoveFile(fileIndex)}>
                            X
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end mt-4">
              <Button variant="contained" onClick={handleCloseModal}>
                cancel
              </Button>
              {openModal.editDocument ? (
                <Button
                  onClick={updateDocument}
                  variant="outlined"
                  className="ms-2"
                  data-bs-dismiss="modal"
                >
                  Update
                </Button>
              ) : (
                <Button
                  onClick={AddDocument}
                  variant="outlined"
                  className="ms-2"
                  data-bs-dismiss="modal"
                >
                  Add
                </Button>
              )}
            </div>
          </div>
        }
      />
    </div>
  );
};

export default DocumentProfile;
